import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { ModalContainer } from '@tassomutuo-backoffice/ui';

import {
  ManagedLeadDetail,
  ManagedLeadProductPath,
} from '../../../services/api/managed-leads/managedLeads';
import ManagedLeadUpdateSection from './ManagedLeadUpdateSection';

interface ManagedLeadUpdateModalProps {
  open: boolean;
  handleClose: () => void;
  product: ManagedLeadProductPath;
  dealId: string;
  detail: ManagedLeadDetail;
}

const DISCARD_CHANGES_MESSAGE =
  'Vuoi uscire senza salvare? Le modifiche inserite andranno perse.';

/** The managed update flow inside the same modal shell used by Mutui. */
const ManagedLeadUpdateModal = ({
  open,
  handleClose,
  product,
  dealId,
  detail,
}: ManagedLeadUpdateModalProps) => {
  const [interaction, setInteraction] = useState({
    dirty: false,
    pending: false,
  });

  const requestClose = useCallback(() => {
    if (interaction.pending) return;
    if (interaction.dirty && !window.confirm(DISCARD_CHANGES_MESSAGE)) return;
    handleClose();
  }, [handleClose, interaction]);

  const complete = useCallback(() => {
    setInteraction({ dirty: false, pending: false });
    handleClose();
  }, [handleClose]);

  return (
    <ModalContainer
      open={open}
      handleClose={requestClose}
      closeDisabled={interaction.pending}
      disableBackdropClose={interaction.dirty}
      stickyFooter
      title="Fornisci aggiornamento"
      containerSx={{
        maxWidth: '500px',
        maxHeight: {
          xs: 'calc(100dvh - 16px)',
          sm: 'calc(100dvh - 32px)',
        },
      }}
      mtHeader={0}
    >
      <Box width="100%" maxWidth="450px">
        <ManagedLeadUpdateSection
          open={open}
          product={product}
          dealId={dealId}
          detail={detail}
          onComplete={complete}
          onRequestClose={requestClose}
          onInteractionStateChange={setInteraction}
        />
      </Box>
    </ModalContainer>
  );
};

export default ManagedLeadUpdateModal;
